import { createFileRoute } from '@tanstack/react-router'
import CreatePurchaseOrderScreen from './-components/screen'
import { pharmacyClient } from '@/connect';
import { Supplier } from '@/gen/suppliers/common_pb';
import { RequestStatus } from '@/gen/purchase_request/common_pb';
import { ListPurchaseRequestsResponse } from '@/gen/purchase_request/list_purchase_requests_pb';
import dayjs from 'dayjs';
import { GetStockPointsResponse } from '@/gen/branch/get_stock_points_pb';

export const Route = createFileRoute('/(inventory)/branch/_layout/purchase-orders/create/')({
  component: CreatePurchaseOrderScreen,
  loader: async (): Promise<{
          suppliers: Supplier[];
          purchaseRequests: ListPurchaseRequestsResponse,
          stockPoints: GetStockPointsResponse
      }> => {
          const suppliers = await pharmacyClient.listSuppliers({
              page: 1,
              pageSize: 1000,
          })
          const purchaseRequests = await pharmacyClient.listPurchaseRequests({
              page: 1,
              pageSize: 1000,
              requestStatus: RequestStatus.PENDING,
          })
          const stockPoints = await pharmacyClient.getStockPoints({
              startDate: dayjs().subtract(30, 'day').unix(),
              endDate: dayjs().unix(),
          })
          return {
              suppliers: suppliers.suppliers as Supplier[],
              purchaseRequests: purchaseRequests,
              stockPoints: stockPoints,
          }
    }
})